import React, { Component } from "react";
import { Container, Row, Col } from 'reactstrap';
import { NavMenu } from '../components/NavMenu';
import { authService } from '../services/auth.service';
import { createBrowserHistory } from 'history';
//import logo from './../assets/img/espol.png';
import logo from './../assets/img/logo-2.svg';
import RevertImpersonationBanner from '../components/RevertImpersonationBanner';

const history = createBrowserHistory();

export class AuthLayout extends Component {

    static displayName = AuthLayout.name;

    constructor(props) {
        super(props);

        this.loginWithMsal = this.loginWithMsal.bind(this);
        this.logout = this.logout.bind(this);
    }

    loginWithMsal() {
        if (this.props.handleMsalLogin) {
            this.props.handleMsalLogin();
        }
    }

    logout() {
        if (this.props.handleLogout) {
            this.props.handleLogout();
        } else {
            authService.logout();
        }
    }

    render() {

        const { currentUser } = this.props;

        return (
            <div className="d-flex flex-column h-100">
                {currentUser && currentUser.isImpersonated && <RevertImpersonationBanner />}
                <Container>
                    <div className="d-flex flex-row">
                        <div className="p-3">
                            <img src={logo} height={80} alt="ESPOL" />
                        </div>
                        <div className="p-4"><h1 className="title text-muted">Sistema de <br />retroalimentación estudiantil</h1></div>
                    </div>
                </Container>
                <NavMenu handleMsalLogin={this.loginWithMsal} handleLogout={this.logout} />
                <main className="flex-shrink-0 bodyContainer">
                    <Container>
                        <div>
                            {this.props.children}
                        </div>
                    </Container>
                </main>
                <footer className="footer mt-auto py-3">
                    <Container className="d-flex justify-content-center">
                        <span className="text-muted text-center">Escuela Superior Politécnica del Litoral - Campus Gustavo Galindo - Guayaquil - Ecuador<br />
                            © El contenido de esta obra es de propiedad de la ESPOL. Todos los derechos reservados.<br />
                            Prohibida su reproducción total o parcial, comunicación pública o distribución sin autorización previa del titular de los derechos.</span>
                    </Container>
                </footer>
            </div>
        );
    }
}